import PropTypes from 'prop-types'
import Svg from '../Components/shared/Svg'

const MapMarkerSvg = ({ className }) => (
  <Svg
    className={className}
    width='26'
    height='34'
    viewBox='0 0 26 34'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g filter='url(#filter0_dd_3393_122672)'>
      <path
        d='M24 11.934C24 20.1908 13 31 13 31C13 31 2 20.1908 2 11.934C2 5.8953 6.92487 1 13 1C19.0751 1 24 5.8953 24 11.934Z'
        fill='#3C94E7'
      />
      <path
        d='M23.5 11.934C23.5 13.8943 22.8448 16.0412 21.8295 18.1821C20.8165 20.3181 19.461 22.4151 18.0974 24.2668C16.7348 26.1171 15.3711 27.7132 14.3476 28.847C13.8361 29.4136 13.4103 29.864 13.1129 30.1722C13.0729 30.2136 13.0352 30.2525 13 30.2887C12.9648 30.2525 12.9271 30.2136 12.8871 30.1722C12.5897 29.864 12.1639 29.4136 11.6524 28.847C10.6289 27.7132 9.26519 26.1171 7.90261 24.2668C6.539 22.4151 5.18348 20.3181 4.17052 18.1821C3.15518 16.0412 2.5 13.8943 2.5 11.934C2.5 6.17428 7.19817 1.5 13 1.5C18.8018 1.5 23.5 6.17428 23.5 11.934Z'
        stroke='#FBF8FA'
        strokeOpacity='0.1'
      />
    </g>
    <path
      d='M20 13.0614L17.3773 10.5171V6.69451H15.6227V8.81682L13 6.27246L6 13.0614V13.4835H7.74849V17.7281H12.1258V15.1837H13.8742V17.7281H18.2515V13.4835H20V13.0614V13.0614Z'
      fill='white'
    />
    <defs>
      <filter
        id='filter0_dd_3393_122672'
        x='0'
        y='0'
        width='26'
        height='34'
        filterUnits='userSpaceOnUse'
        colorInterpolationFilters='sRGB'
      >
        <feFlood floodOpacity='0' result='BackgroundImageFix' />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='0.5' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0588235 0 0 0 0.06 0'
        />
        <feBlend
          mode='normal'
          in2='BackgroundImageFix'
          result='effect1_dropShadow_3393_122672'
        />
        <feColorMatrix
          in='SourceAlpha'
          type='matrix'
          values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
          result='hardAlpha'
        />
        <feOffset dy='1' />
        <feGaussianBlur stdDeviation='1' />
        <feComposite in2='hardAlpha' operator='out' />
        <feColorMatrix
          type='matrix'
          values='0 0 0 0 0.0392157 0 0 0 0 0.0392157 0 0 0 0 0.0588235 0 0 0 0.1 0'
        />
        <feBlend
          mode='normal'
          in2='effect1_dropShadow_3393_122672'
          result='effect2_dropShadow_3393_122672'
        />
        <feBlend
          mode='normal'
          in='SourceGraphic'
          in2='effect2_dropShadow_3393_122672'
          result='shape'
        />
      </filter>
    </defs>
  </Svg>
)

MapMarkerSvg.propTypes = {
  className: PropTypes.string,
}

export default MapMarkerSvg
